import React from 'react';

const FFTheme1 = (props) => {
	return <div className='ff-theme1'>FFTheme1</div>;
};

export default FFTheme1;
